// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CzFHA","rootMobile":"styles_rootMobile__LaPEw"};